const Logo = ({ ...rest }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="345"
            height="62"
            viewBox="0 0 345 62"
            fill="none"
            {...rest}
        >
            <g clipPath="url(#clip0_4_171)">
                <g clipPath="url(#clip1_4_171)">
                    <g clipPath="url(#clip2_4_171)">
                        <path
                            d="M31.4634 35.2209C40.0011 34.9135 48.5382 34.6054 57.0747 34.298C55.4827 31.6665 55.0845 29.3645 52.0416 28.9676C47.4874 28.3754 42.9331 27.7813 38.3782 27.1872C29.5438 26.0362 20.7068 24.8852 11.8711 23.7348C12.6636 25.0137 25.0261 35.4521 31.4634 35.2209Z"
                            fill="url(#paint0_linear_4_171)"
                            className="logo-wings"
                        />
                        <path
                            d="M0 8C2.76632 12.5719 16.7674 22.5353 20.7603 23.0481C31.6782 24.4537 42.5942 25.8579 53.5114 27.2616C51.3738 23.7292 50.878 21.3711 47.0148 20.3574C41.4053 18.8826 35.7933 17.4071 30.1832 15.9329C20.1221 13.2895 10.0611 10.6447 0 8Z"
                            fill="url(#paint1_linear_4_171)"
                            className="logo-wings"
                        />
                        <path
                            d="M39.758 43.5451C46.3181 42.1471 52.8783 40.7485 59.4397 39.3493C58.1621 37.2413 58.1583 35.9732 55.7687 36.0803C51.8892 36.2523 48.0109 36.4261 44.132 36.5981C36.986 36.9169 29.8399 37.2369 22.6945 37.5545C23.4977 38.415 34.6121 44.6413 39.758 43.5451Z"
                            fill="url(#paint2_linear_4_171)"
                            className="logo-wings"
                        />
                        <path
                            d="M55.2395 58.6689C58.8462 56.3259 59.8145 53.8047 61.8664 49.9705C64.1666 45.6714 62.6584 45.0288 60.0892 40.775C59.8265 40.3416 56.4088 40.9212 56.0239 41.3446C55.5545 41.8599 55.8676 44.7812 55.8386 45.437C55.6383 49.8476 55.4386 54.2589 55.2395 58.6689Z"
                            fill="url(#paint3_linear_4_171)"
                            className="logo-wings"
                        />
                        <path
                            d="M54.4003 41.8063C52.0095 42.316 48.9798 41.9267 48.37 44.4706C47.505 48.0843 46.64 51.6998 45.7744 55.3135C51.5994 53.9218 54.1975 46.9314 54.4003 41.8063Z"
                            fill="url(#paint4_linear_4_171)"
                            className="logo-wings"
                        />
                        <path
                            d="M47.0394 43.491C41.2762 44.7214 41.3971 46.3959 38.9257 51.7943C42.8442 51.4226 46.5008 47.1576 47.0394 43.491Z"
                            fill="url(#paint5_linear_4_171)"
                            className="logo-wings"
                        />
                    </g>
                </g>
                <path
                    d="M77.505 53V12.4547H83.3897V53H77.505ZM88.7478 53V12.4547H94.6325V47.4532H112.99V53H88.7478ZM114.674 53V12.4547H120.558V53H114.674ZM122.538 53L135.715 12.4547H144.19L157.367 53H151.257L139.122 16.0025H140.642L128.648 53H122.538ZM129.38 43.8492V38.3305H150.553V43.8492H129.38ZM172.356 53.8447C169.447 53.8447 166.819 53.3473 164.472 52.3524C162.145 51.3388 160.221 49.9028 158.7 48.0445C157.199 46.1674 156.222 43.943 155.772 41.3714L161.91 40.4422C162.53 42.92 163.825 44.8534 165.796 46.2425C167.767 47.6127 170.066 48.2979 172.694 48.2979C174.327 48.2979 175.829 48.0445 177.199 47.5377C178.569 47.0121 179.667 46.2706 180.493 45.3133C181.338 44.3372 181.76 43.1734 181.76 41.8219C181.76 41.0898 181.629 40.4422 181.366 39.8791C181.122 39.316 180.775 38.8279 180.324 38.415C179.893 37.9832 179.358 37.6172 178.719 37.3169C178.1 36.9978 177.415 36.7256 176.664 36.5003L166.274 33.4313C165.261 33.1309 164.228 32.7461 163.177 32.2769C162.126 31.7888 161.159 31.16 160.277 30.3904C159.414 29.602 158.71 28.6353 158.165 27.4903C157.621 26.3265 157.349 24.9187 157.349 23.2668C157.349 20.7703 157.987 18.6585 159.263 16.9316C160.559 15.1859 162.304 13.872 164.5 12.9897C166.697 12.0887 169.156 11.6382 171.877 11.6382C174.618 11.6758 177.068 12.1638 179.226 13.1023C181.404 14.0409 183.206 15.3924 184.632 17.1569C186.078 18.9026 187.073 21.0237 187.617 23.5202L181.31 24.5902C181.028 23.0697 180.428 21.7651 179.508 20.6764C178.588 19.5689 177.462 18.7242 176.129 18.1423C174.796 17.5417 173.351 17.232 171.793 17.2132C170.291 17.1756 168.912 17.4009 167.654 17.8889C166.415 18.377 165.42 19.0621 164.669 19.9444C163.937 20.8266 163.571 21.8402 163.571 22.9852C163.571 24.1115 163.9 25.0219 164.557 25.7164C165.214 26.4109 166.021 26.9647 166.978 27.3777C167.954 27.7718 168.921 28.1003 169.878 28.3631L177.368 30.4749C178.306 30.7377 179.367 31.0943 180.55 31.5448C181.751 31.9765 182.905 32.5866 184.013 33.375C185.139 34.1634 186.068 35.2145 186.8 36.5285C187.532 37.8237 187.898 39.4568 187.898 41.4277C187.898 43.4737 187.485 45.2758 186.66 46.8337C185.834 48.373 184.698 49.6682 183.253 50.7193C181.826 51.7517 180.174 52.5307 178.297 53.0563C176.42 53.5819 174.44 53.8447 172.356 53.8447ZM195.036 53L208.213 12.4547H216.688L229.866 53H223.756L211.62 16.0025H213.141L201.146 53H195.036ZM201.878 43.8492V38.3305H223.052V43.8492H201.878ZM231.82 53V12.4547H237.705V47.4532H256.063V53H231.82ZM257.746 53V12.4547H263.63V47.4532H281.988V53H257.746ZM283.109 53V12.4547H309.012V18.0016H288.993V29.3768H305.634V34.9236H288.993V47.4532H309.012V53H283.109ZM312.114 53V12.4547H317.999V31.3759L334.977 12.4547H342.298L324.362 32.2487L343.621 53H336.075L317.999 33.6284V53H312.114Z"
                    fill="url(#paint6_linear_4_171)"
                    className="logo-name"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_4_171"
                    x1="34.4729"
                    y1="23.7348"
                    x2="34.4729"
                    y2="35.2247"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#274035" />
                    <stop offset="1" stopColor="#052360" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_4_171"
                    x1="26.7557"
                    y1="8"
                    x2="26.7557"
                    y2="27.2616"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#274035" />
                    <stop offset="1" stopColor="#052360" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_4_171"
                    x1="41.0671"
                    y1="36.074"
                    x2="41.0671"
                    y2="43.6741"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#274035" />
                    <stop offset="1" stopColor="#052360" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_4_171"
                    x1="59.1198"
                    y1="40.6216"
                    x2="59.1198"
                    y2="58.6689"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#274035" />
                    <stop offset="1" stopColor="#052360" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_4_171"
                    x1="50.0874"
                    y1="41.8063"
                    x2="50.0874"
                    y2="55.3135"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#274035" />
                    <stop offset="1" stopColor="#052360" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_4_171"
                    x1="42.9825"
                    y1="43.491"
                    x2="42.9825"
                    y2="51.7943"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#274035" />
                    <stop offset="1" stopColor="#052360" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_4_171"
                    x1="73"
                    y1="38.5"
                    x2="341"
                    y2="35.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#274035" />
                    <stop offset="1" stopColor="#274035" />
                </linearGradient>
                <clipPath id="clip0_4_171">
                    <rect width="345" height="62" fill="white" />
                </clipPath>
                <clipPath id="clip1_4_171">
                    <rect
                        width="63"
                        height="50.6688"
                        fill="white"
                        transform="translate(0 8)"
                    />
                </clipPath>
                <clipPath id="clip2_4_171">
                    <rect
                        width="63"
                        height="50.6688"
                        fill="white"
                        transform="translate(0 8)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Logo;
